{
  "product-happy-hour-dialog": {
    "buttons": {
      "close": "Zavřít"
    },
    "text": {
      "happy-hour": "Šťastná hodina",
      "to": "až"
    }
  },
  "product-promotion-dialog": {
    "buttons": {
      "close": "Zavřít"
    },
    "text": {
      "from-date-to-date": "od {{from}} do {{to}}"
    }
  },
  "salon-service-selection": {
    "buttons": {
      "select": "Vyberte",
      "selected": "Vybrané stránky"
    },
    "text": {
      "discount-details": "Podrobnosti o slevě",
      "minutes": "minuty"
    }
  }
}
